import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  userId: string;
  public handler: any;
  public charger: any;
  amount = 499;
  userEmail;
  data$;

  // tslint:disable-next-line: no-shadowed-variable
  constructor(
    private db: AngularFireDatabase,
    private afAuth: AngularFireAuth,
    private fns: AngularFireFunctions,
    private router: Router,
    private ngZone: NgZone
  ) {


    this.handler = StripeCheckout.configure({
      key: environment.stripeKey,
      // tslint:disable-next-line: max-line-length
      image: 'https://firebasestorage.googleapis.com/v0/b/insider-trading-alerts.appspot.com/o/icon-128.png?alt=media&token=bed0f82d-9cf4-4663-a024-b76b7b3a12cb',
      locale: 'auto',
      token: token => {
        this.processPayment(token, this.amount);
      }
    });

    this.afAuth.onAuthStateChanged((user) => {
      if (user) {
        const isAnonymous = user.isAnonymous;
        this.userId = user.uid;
      }
    });
  }

  signIn() {
    this.afAuth.signInAnonymously()
      .then((result) => {
        this.handlePayment();
      }).catch((error) => {
        console.log('error signing in anonymously: ', error);
      });
  }

  handlePayment() {
    this.handler.open({
      name: 'Insider Trading Alerts',
      description: 'Get access to all features now.',
      amount: this.amount
    });
  }

  chargePayment(token, paymentId) {
    const amount = this.amount;
    const userId = this.userId;
    const currency = 'usd';
    const data = { amount, paymentId, token, userId, currency };
    const callable = this.fns.httpsCallable('chargePayment');
    this.data$ = callable(data).subscribe(
      res => {
        this.ngZone.run(() => {
          this.router.navigate(['/success'], { queryParams: { success: true, message: res } });
        });
      },
      (err) => {
        console.log('payment error: ', err.message);
        this.ngZone.run(() => {
          this.router.navigate(['/success'], { queryParams: { success: false, message: err.message } });
        });
      }
    );
  }

  processPayment(token, amount) {
    const payment = { token, amount };
    return this.db.list(`/payments/${this.userId}`).push(payment)
      .then(res => {
        // tslint:disable-next-line: no-string-literal
        // tslint:disable-next-line: no-string-literal
        const paymentId = res['path']['pieces_'][2];
        this.chargePayment(payment.token, paymentId);
      })
      .catch((error) => {
        this.ngZone.run(() => {
          this.router.navigate(['/success'], { queryParams: { success: false, message: error.message } });
        });
      });

  }

}
